import { formatDate } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { RentalReportFilterModel } from 'src/app/models/rental/rental-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ClientService } from 'src/app/services/archive/client.service';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { ZoneService } from 'src/app/services/archive/zone.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { RentalReportService } from 'src/app/services/rental/rental-report.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-days-construction-site',
  templateUrl: './days-construction-site.component.html',
  styleUrls: ['./days-construction-site.component.scss'],
  standalone: false
})
export class DaysConstructionSiteComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  daysMark: number = 20;
  filterObserver?: ResizeObserver;
  filtersHeight: number = 0;
  filteredStores: any[] = [];
  formRentalReportFilter: FormGroup = new FormGroup({});
  listArticle: any[] = [];
  listBranch: any[] = [];
  listClient: any[] = [];
  listCostCenter: any[] = [];
  listInventory: any[] = [];
  listStore: any[] = [];
  listZone: any[] = [];
  nameWindow: string = 'Informe días de Equipo en Obra';
  projectName = ProjectName.projectName;

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private clientService: ClientService,
    private costCenterService: CostCenterService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private rentalPeriodService: RentalPeriodService,
    private rentalReportService: RentalReportService,
    private storeService: StoreService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private zoneService: ZoneService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.getFirstBranchByUserAuthenticatedAsync();
    await this.getAllLists();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();
  }

  changeArticle(articleId: number | null) {
    if (articleId === 0 || articleId === null || articleId === undefined) {
      this.formRentalReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeCostCenter(costCenterId: number | null) {
    if (costCenterId === 0 || costCenterId === null || costCenterId === undefined) {
      this.formRentalReportFilter.controls["costCenterId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  changeZone(zoneId: number | null) {
    if (zoneId === 0 || zoneId === null || zoneId === undefined) {
      this.formRentalReportFilter.controls["zoneId"].patchValue(0);
    }
    this.changeFilter();
  }

  clear() {
    this.changeFilter();
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
    this.daysMark = 20;
    this.formRentalReportFilter.controls["daysMark"].patchValue(this.daysMark);
  }

  async changeClient(clientId: number | null) {
    this.formRentalReportFilter.controls["costCenterId"].patchValue(0);
    this.changeFilter();
    if (clientId && clientId !== 0) {
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(clientId, 0));
    } else {
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0));
      this.formRentalReportFilter.controls["clientId"].patchValue(0);
    }
  }

  changeInventory(inventoryId: number | null) {
    this.filterStoreByInventoryId(inventoryId);
    if (inventoryId != 0 && inventoryId != null) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    } else {
      this.formRentalReportFilter.controls["inventoryId"].patchValue(0);
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeStore(storeId: number | null) {
    if (storeId === 0 || storeId === null || storeId === undefined) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    }
    this.changeFilter();
  }

  changedDaysMark(event: number) {
    this.daysMark = event;
  }

  async exportExcel() {
    if (this.changeFilters) {
      const modelRentalReportFilter = this.formRentalReportFilter.value as RentalReportFilterModel;
      const dateFinal = this.formRentalReportFilter.get("finalDate")?.value;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = finalDate.slice(5);
      const year = finalDate.slice(0, -3);

      modelRentalReportFilter.year = parseInt(year);
      modelRentalReportFilter.period = parseInt(period);
      modelRentalReportFilter.byStores = true;
      try {
        const response = await firstValueFrom(this.rentalReportService.exportRentalReportDaysConstructionSite(modelRentalReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe Días de Equipo en Obra.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterStoreByInventoryId(inventoryId: number | null) {
    const rowsFiltered = this.listStore.filter(x => x.inventoryId === inventoryId);
    if (inventoryId != null) {
      this.filteredStores = rowsFiltered;
    } else {
      this.filteredStores = this.listStore;
    }
    this.formRentalReportFilter.controls["storeId"].patchValue(0);
  }

  async getAllLists() {
    try {
      const [branches, zones, clients, costCenters, articles, inventories, stores] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.zoneService.getAllZonesForSelectAsync()),
        firstValueFrom(this.clientService.getAllClientsForSelectAsync()),
        firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0)),
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
        firstValueFrom(this.inventoryService.getAllInventoriesForSelectReportAsync()),
        firstValueFrom(this.storeService.getAllStoresForSelectAsync())
      ]);
      this.listBranch = branches;
      this.listZone = zones;
      this.listClient = clients;
      this.listCostCenter = costCenters;
      this.listArticle = articles;
      this.listInventory = inventories;
      this.listStore = stores;
      this.filteredStores = this.listStore;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formRentalReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.formRentalReportFilter.controls["finalDate"].patchValue(this.dateConverterService.convertDatePreserveDay(new Date()));
      this.filteredStores = this.listStore;
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formRentalReportFilter.controls).forEach(key => {
      const control = this.formRentalReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formRentalReportFilter.valid) {
      const modelRentalReportFilter = this.formRentalReportFilter.getRawValue() as RentalReportFilterModel;
      const dateFinal = this.formRentalReportFilter.get("finalDate")?.value;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = finalDate.slice(5);
      const year = finalDate.slice(0, -3);

      modelRentalReportFilter.year = parseInt(year);
      modelRentalReportFilter.period = parseInt(period);
      modelRentalReportFilter.byStores = true;

      try {
        this.dataReport = await firstValueFrom(this.rentalReportService.rentalReportDaysConstructionSite(modelRentalReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      finalDate: {
        required: 'El campo Fecha es obligatorio.'
      },
      clientId: {
        notNumber: 'Debe seleccionar un Cliente válido.'
      },
      costCenterId: {
        notNumber: 'Debe seleccionar un C.Costos válido.'
      },
      zoneId: {
        notNumber: 'Debe seleccionar una Zona válida.'
      },
      articleId: {
        notNumber: 'Debe seleccionar un Artículo válido.'
      },
      inventoryId: {
        notNumber: 'Debe seleccionar un Inventario válido.'
      },
      storeId: {
        notNumber: 'Debe seleccionar una Bodega válida.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formRentalReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formRentalReportFilter = this.formBuilder.group({
      branchId: [0, [Validators.required, Validators.min(1)]],
      finalDate: [formatDate(new Date, "yyyy-MM-dd", "en-US"), [Validators.required]],
      daysMark: [this.daysMark, [Validators.required]],
      clientId: [0, [CustomValidators.numberOnlyValidator()]],
      costCenterId: [0, [CustomValidators.numberOnlyValidator()]],
      zoneId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]],
      inventoryId: [0, [CustomValidators.numberOnlyValidator()]],
      storeId: [0, [CustomValidators.numberOnlyValidator()]],
      articleName: [""]
    });
  }

}
